export default __webpack_public_path__ + "static/media/LEAKAGE_Dashboard.8dd3198c.svg";